export default "__VITE_ASSET__u2DyUm0y__"